import { render, staticRenderFns } from "./WuzihuikudiaopeiByIdForm.vue?vue&type=template&id=16e98f0a&scoped=true&"
import script from "./WuzihuikudiaopeiByIdForm.vue?vue&type=script&lang=js&"
export * from "./WuzihuikudiaopeiByIdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e98f0a",
  null
  
)

export default component.exports